import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LoadingController, NavParams, PopoverController } from '@ionic/angular';
import { AgregaraudioComponent } from '../agregaraudio/agregaraudio.component';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { Router } from '@angular/router';

@Component({
  selector: 'app-carrusel',
  templateUrl: './carrusel.component.html',
  styleUrls: ['./carrusel.component.scss'],
})
export class CarruselComponent implements OnInit  {
  @ViewChild("sliderRef") sliderRef!: ElementRef<HTMLElement>

  currentSlide: number = 0;
  dotHelper: Array<Number> = []
  slider: KeenSliderInstance | null = null

  
  jsonPeluche;
  constructor(public poper: PopoverController, public navParams: NavParams, public router: Router,
    public loadingController: LoadingController, public popoverController: PopoverController,
    private cd: ChangeDetectorRef
  ) { 
    this.jsonPeluche = this.navParams.get('peluche'); 
    setTimeout(() => {
      this.loadSlider();
      this.cd.detectChanges();
    }, 200);
    //this.loadSlider();
  }

  ngOnInit() {
  }

  loadSlider() {
    setTimeout(() => {
      this.slider = new KeenSlider(this.sliderRef.nativeElement, {
        initial: this.currentSlide,
        slideChanged: (s) => {
          this.currentSlide = s.track.details.rel
        },
      })
      this.dotHelper = [
        ...Array(this.slider.track.details.slides.length).keys(),
      ]
    })
  }

   ngOnDestroy() {
    if (this.slider) this.slider.destroy()
  }

  async cerarPopOver(){  
    this.poper.dismiss(); 
  }

  async abrirPeluche(id: any, imagen: any, precio: any, descripcion: any, nombre: any, value: any, medida: any) {
          const loading = await this.loadingController.create({
            message: "ʕ•́ᴥ•̀ʔっ"
          });
          this.router.navigate(['/agregaraudio'],
            { queryParams: {id: id, imagen: imagen, precio: precio, descripcion: descripcion, nombre: nombre, value: value, medida: medida} }
          );

          await loading.present(); 

          loading.dismiss();      
  }  
}
